<template>
  <v-data-table
    :headers="headers"
    :items="questions"
    :items-per-page="20"
    v-bind="$attrs"
  >
    <template #[`item.missing_translations`]="{ item }">
      <v-icon
        :color="isMissingTranslations(item) ? 'orange' : 'green'"
        v-text="isMissingTranslations(item) ? 'mdi-alert-circle' : 'mdi-check-circle'"
      />
    </template>
    <template #[`item.default_translation.title`]="{ item }">
      <inertia-link
        :href="route('faq.question-translation.index', [faqId, item.id])"
        :preserve-state="true"
        :preserve-scroll="true"
      >
        {{ item.default_translation.title }}
      </inertia-link>
    </template>
    <template #[`item.category_id`]="{ item }">
      {{ categories[item.category_id].default_translation.name }}
    </template>
    <template #[`item.subcategory_id`]="{ item }">
      <span v-if="item.subcategory_id">
        {{ subcategories[item.subcategory_id].default_translation.name }}
      </span>
      <span v-else>
        -
      </span>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    faqId: {
      type: Number,
      required: true
    },
    questions: {
      type: Array,
      required: true
    },
    categories: {
      type: Object,
      required: true,
    },
    subcategories: {
      type: Object,
      required: true,
    },
    missingTranslations: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      headers: [
        { text: '', value: 'missing_translations', width: 70 },
        { text: this.$t('Question title'), value: 'default_translation.title' },
        {
          text: this.$t('Category'),
          value: 'category_id',
          sort: (catIdA, catIdB) =>  {
            const catNameA = this.categories[catIdA].default_translation.name;
            const catNameB = this.categories[catIdB].default_translation.name;

            if (catNameA < catNameB) {
              return -1;
            }

            if (catNameA > catNameB) {
              return 1;
            }

            return 0;
          }
        },
        {
          text: this.$t('Subcategory'),
          value: 'subcategory_id',
          sort: (subcatIdA, subcatIdB) =>  {
            const subcatNameA = this.categories[subcatIdA] ? this.categories[subcatIdA].default_translation.name : null;
            const subcatNameB = this.categories[subcatIdB] ? this.categories[subcatIdB].default_translation.name : null;

            if (subcatNameA < subcatNameB) {
              return -1;
            }

            if (subcatNameA > subcatNameB) {
              return 1;
            }

            return 0;
          }
        },
      ],
    }
  },

  methods: {
    isMissingTranslations(model) {
      return model.translations.some(translation => {
        return this.missingTranslations.questions[model.id][translation.language_code];
      });
    }
  },
}
</script>

<style>
.v-data-table {
  white-space: nowrap !important;
}
</style>